import React from 'react';
import ReactDOM from 'react-dom';
import { List, Popover, TagBox } from 'devextreme-react';

class Select extends React.PureComponent {
  render() {
    let rawData = this.props.dataSource.filter(r => r.Id !== 6 && r.Id !== 8)
    rawData.forEach(rol => {
      if (rol.Code === "PER_EMPRESA_ROL_ADMIN") {
        rol.order = 1
        rol.Name = "Administrador"
      } else if (rol.Code === "PER_EMPRESA_ROL_FULL") {
        rol.order = 2
      } else if (rol.Code === "PER_EMPRESA_ROL_RRHH") {
        rol.order = 3
      } else if (rol.Code === "PER_EMPRESA_ROL_PREVENCIONISTA") {
        rol.order = 4
      } else if (rol.Code === "PER_EMPRESA_ROL_SERVICIO_DE_EVALUACIÓN_") {
        rol.order = 5
      }
    })
    let sortedData = rawData.sort((a, b) => Number(a.order) - Number(b.order));
    return (
      <div
        onClickCapture={() => {
          this.props.openClose(true);
        }}
      >
        <TagBox
          placeholder='Permisos'
          id={`tagBoxroles${this.props.title}`}
          dataSource={this.props.dataSource}
          className="tag-box-roles"
          onInitialized={(e) => {
            e.component.option("openOnFieldClick", false);
          }}
          displayExpr="Name"
          hideSelectedItems
          valueExpr="Id"
          disabled={this.props.disabled}
          onValueChanged={this.props.onSelection}
          value={this.props.selectedItems}
          itemComponent={(props) => (
            <div className="solicitudes-tagbox-item" >
              <span>{props.Name}</span>
              <div>{props.Description}</div>
            </div>
          )}
        />
        {this.props.open && (
          <Popover
            target={`#tagBoxroles${this.props.title}`}
            className="popover-roles-portales"
            position={{ offset: "0 22", my: "top" }}
            visible={this.props.open}
            width={558}
            onHidden={() => this.props.openClose(false)}
            defaultVisible
            maxHeight={240}
            closeOnOutsideClick
          >
            <List
              dataSource={sortedData}
              className="lista-roles-portales"
              pageLoadMode="scrollBottom"
              selectionMode="multiple"
              ref={(ref) => { if (ref != null) this.listRef = ref.instance; }}
              onSelectionChanged={(e) => {
                const event = { value: e.component.option("selectedItemKeys") };
                if (e.removedItems.length) {
                  const prev = e.removedItems.map((ev) => ev.Id);
                  event.previousValue = [...event.value, ...prev];
                }
                this.props.onSelection(event);
                this.props.openClose(false);
              }}
              keyExpr="Id"
              searchEnabled
              searchEditorOptions={{
                focusStateEnabled: true,
              }}
              searchTimeout={300}
              searchExpr={["Name"]}
              showSelectionControls
              defaultSelectedItemKeys={this.props.selectedItems}
              indicateLoading={false}
              pageLoadingText="No hay mas registros"
              itemTemplate={(itemData, _index, element) => {
                ReactDOM.render(
                  <p className='select-item-muted'>
                    <strong>{itemData.Name}</strong>: {itemData.Description}
                  </p>,
                  element
                );
              }}
            />
          </Popover>
        )}
      </div>
    );
  }
}

export default Select;
